import { useScanDeviceApiUpsert } from '@hooks/api/useScanDeviceApiUpsert';
import type { HardwareVersion } from 'types/api';

export const useHardwareVersionUpsert = useScanDeviceApiUpsert<
  HardwareVersion,
  Partial<Omit<HardwareVersion, 'id'>>
>('/hardware-versions');
